const AuthTypes = {
  LOGIN_IN_PROGRESS: 'AUTH_TYPES.LOGIN_IN_PROGRESS',
  LOGIN_IN_SUCCESS: 'AUTH_TYPES.LOGIN_IN_SUCCESS',
  LOGIN_IN_ERROR: 'AUTH_TYPES.LOGIN_IN_ERROR',
  GET_USER_MENU_PROGRESS: 'AUTH_TYPES.GET_USER_MENU_PROGRESS',
  GET_USER_MENU_SUCCESS: 'AUTH_TYPES.GET_USER_MENU_SUCCESS',
  GET_USER_MENU_ERROR: 'AUTH_TYPES.GET_USER_MENU_ERROR',
  GET_USER_MENU_ITEMS_PROGRESS: 'AUTH_TYPES.GET_USER_MENU_ITEMS_PROGRESS',
  GET_USER_MENU_ITEMS_SUCCESS: 'AUTH_TYPES.GET_USER_MENU_ITEMS_SUCCESS',
  GET_USER_MENU_ITEMS_ERROR: 'AUTH_TYPES.GET_USER_MENU_ITEMS_ERROR',
  SET_SELECTED_COMPANY: 'AUTH_TYPES.SET_SELECTED_COMPANY',
  FORGOT_PASSWORD_PROGRESS: 'AUTH_TYPES.FORGOT_PASSWORD_PROGRESS',
  FORGOT_PASSWORD_SUCCESS: 'AUTH_TYPES.FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'AUTH_TYPES.FORGOT_PASSWORD_ERROR',
  RESET_FORGOT_PASSWORD: 'AUTH_TYPES.RESET_FORGOT_PASSWORD',
  USER_REGISTRATION_PROGRESS: 'AUTH_TYPES.USER_REGISTRATION_PROGRESS',
  USER_REGISTRATION_SUCCESS: 'AUTH_TYPES.USER_REGISTRATION_SUCCESS',
  USER_REGISTRATION_ERROR: 'AUTH_TYPES.REGISTRATION_ERROR',
  RESET_USER_REGISTRATION: 'AUTH_TYPES.RESET_USER_REGISTRATION',
  GET_USER_PROFILE_PROGRESS: 'AUTH_TYPES.GET_USER_PROFILE_PROGRESS',
  GET_USER_PROFILE_SUCCESS: 'AUTH_TYPES.GET_USER_PROFILE_SUCCESS',
  GET_USER_PROFILE_ERROR: 'AUTH_TYPES.GET_USER_PROFILE_ERROR',
  USER_PROFILE_UPDATE_PROGRESS: 'AUTH_TYPES.USER_PROFILE_UPDATE_PROGRESS',
  USER_PROFILE_UPDATE_SUCCESS: 'AUTH_TYPES.USER_PROFILE_UPDATE_SUCCESS',
  USER_PROFILE_UPDATE_ERROR: 'AUTH_TYPES.USER_PROFILE_UPDATE_ERROR',

  UPDATE_USER_PASSWORD_PROGRESS: 'AUTH_TYPES.UPDATE_USER_PASSWORD_PROGRESS',
  UPDATE_USER_PASSWORD_SUCCESS: 'AUTH_TYPES.UPDATE_USER_PASSWORD_SUCCESS',
  UPDATE_USER_PASSWORD_ERROR: 'AUTH_TYPES.UPDATE_USER_PASSWORD_ERROR',

  UPDATE_USER_PREFERENCE_PROGRESS: 'AUTH_TYPES.UPDATE_USER_PREFERENCE_PROGRESS',
  UPDATE_USER_PREFERENCE_SUCCESS: 'AUTH_TYPES.UPDATE_USER_PREFERENCE_SUCCESS',
  UPDATE_USER_PREFERENCE_ERROR: 'AUTH_TYPES.UPDATE_USER_PREFERENCE_ERROR',

  GET_USER_PREFERENCE_PROGRESS: 'AUTH_TYPES.GET_USER_PREFERENCE_PROGRESS',
  GET_USER_PREFERENCE_SUCCESS: 'AUTH_TYPES.GET_USER_PREFERENCE_SUCCESS',
  GET_USER_PREFERENCE_ERROR: 'AUTH_TYPES.GET_USER_PREFERENCE_ERROR',

  CHANGE_COMPANY_IN_PROGRESS: 'AUTH_TYPES.CHANGE_COMPANY_IN_PROGRESS',
  CHANGE_COMPANY_IN_SUCCESS: 'AUTH_TYPES.CHANGE_COMPANY_IN_SUCCESS',
  CHANGE_COMPANY_IN_FAIL: 'AUTH_TYPES.CHANGE_COMPANY_IN_FAIL',

  APPROVE_REJECT_SHIPMENT_IN_PROGRESS: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_PROGRESS',
  APPROVE_REJECT_SHIPMENT_IN_SUCCESS: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_SUCCESS',
  APPROVE_REJECT_SHIPMENT_IN_FAIL: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_FAIL',

  UPDATE_USER_PROFILE_IMAGE_PROGRESS: 'AUTH_TYPES.UPDATE_USER_PROFILE_IMAGE_PROGRESS',
  UPDATE_USER_PROFILE_IMAGE_SUCCESS: 'AUTH_TYPES.UPDATE_USER_PROFILE_IMAGE_SUCCESS',
  UPDATE_USER_PROFILE_IMAGE_ERROR: 'AUTH_TYPES.UPDATE_USER_PROFILE_IMAGE_ERROR',
};

export default AuthTypes;
